import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { getUserProjects } from "authoring/users/projects/controller/get-user-projects"
import { AuthoringHomeStatTile } from "../authoring-home-stat-tile"

export function AuthoringHomeWorkPackagesTile() {
    const result = getUserProjects.useResults({}, withInitialValue(IS_LOADING))
    const count = result === IS_LOADING ? IS_LOADING : result?.total ?? 0

    return (
        <AuthoringHomeStatTile
            title="Work Package"
            pluralTitle="Work Packages"
            count={count}
            icon="mdi:folder-multiple-outline"
            palette="primary"
            to="/authoring/projects"
        />
    )
}
